import React from "react";
import "./Navbar.css";


function Navbar() {
  return (
    <nav className="navbar">
     

      <ul>
        <li><a href="#home">Inicio</a></li>
        <li><a href="#cover-art">Cover Art</a></li>
        <li><a href="#reels">Reels</a></li>
        <li><a href="#edits">Edits</a></li>
        <li><a href="#plans">Planes</a></li>
      </ul>
    </nav>
  );
}

export default Navbar;
